var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FBBA06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H8C5.33333 4 4 5.33333 4 8V28L8 24H24C26.6667 24 28 22.6667 28 20V8C28 5.33333 26.6667 4 24 4ZM17.3333 17.6667H10.6667C10.1147 17.6667 9.66667 17.2187 9.66667 16.6667C9.66667 16.1147 10.1147 15.6667 10.6667 15.6667H17.3333C17.8853 15.6667 18.3333 16.1147 18.3333 16.6667C18.3333 17.2187 17.8853 17.6667 17.3333 17.6667ZM21.3333 12.3333H10.6667C10.1147 12.3333 9.66667 11.8853 9.66667 11.3333C9.66667 10.7813 10.1147 10.3333 10.6667 10.3333H21.3333C21.8853 10.3333 22.3333 10.7813 22.3333 11.3333C22.3333 11.8853 21.8853 12.3333 21.3333 12.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.58ed1d9bf448f45a9ac3cdf88573b270.svg";
export { ForwardRef as ReactComponent };